import { BaseAction } from '../../@types/Action';
import validationMethods from './validationMethods';

export interface LoginFormValidation {
  email: boolean;
  password: boolean;
}
export interface LoginForm {
  email: string;
  password: string;
}

export interface LoginState {
  value: LoginForm;
  interact: LoginFormValidation;
  validation: LoginFormValidation;
}

export const initialState = (): LoginState => ({
  value: {
    email: '',
    password: '',
  },
  validation: {
    email: false,
    password: false,
  },
  interact: {
    email: false,
    password: false,
  },
});

export const SET_CHANGE = 'SET_CHANGE';
type SET_CHANGE_TYPE = BaseAction<typeof SET_CHANGE> & {
  name: keyof LoginForm;
  value: string;
};

export const SET_BLUR = 'REQ_BLSET_BLURUR';
type SET_BLUR_TYPE = BaseAction<typeof SET_BLUR> & {
  name: keyof LoginForm;
};

export const SET_VALIDATE_EVERYTHING = 'SET_VALIDATE_EVERYTHING';
export type SET_VALIDATE_EVERYTHING_TYPE = BaseAction<typeof SET_VALIDATE_EVERYTHING>;

type LoginAction = SET_CHANGE_TYPE | SET_BLUR_TYPE | SET_VALIDATE_EVERYTHING_TYPE;

const loginReducer = (state: LoginState, action: LoginAction) => {
  const next = { ...state };
  switch (action.type) {
    case SET_CHANGE:
      next.value[action.name] = action.value;
      next.validation[action.name] = validationMethods[action.name](action.value);
      return next;
    case SET_BLUR:
      next.interact[action.name] = true;
      return next;
    case SET_VALIDATE_EVERYTHING:
      next.validation.email = validationMethods.email(next.value.email);
      next.interact.email = true;

      next.validation.password = validationMethods.password(next.value.password);
      next.interact.password = true;
      return next;
    default:
      throw new Error(`Unsupported action type`);
  }
};

export default loginReducer;
